module.exports = __webpack_public_path__ + "media/images/underground_mine-6e51b0a856e01aae1d61bf53282eb293.png";